module.exports = __webpack_public_path__ + "media/images/partner/media/wdr-683b3a0c47f61245ae197abf78ad1c3b.png";